import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Inbox, ArrowRight } from "lucide-react";

// Requester-side twin of NearbyHelp (user request, 2026-07): when someone
// offers on your open help request, surface it prominently on the dashboard.
// Links into the request detail page, where the ApplicantsPanel ("Offers to
// help") already provides accept / decline / message actions.
export const ReviewOffers = () => {
  const [data, setData] = useState(null);

  useEffect(() => { api.myHelpOffers().then(setData).catch(() => setData(null)); }, []);

  if (!data || !data.total_pending) return null;
  const n = data.total_pending;

  return (
    <div data-testid="review-offers-card" className="mt-6 bg-amber-50 border border-amber-200 rounded-2xl p-6">
      <div className="text-xs uppercase tracking-[0.18em] text-amber-800 font-bold flex items-center gap-1.5">
        <Inbox className="w-4 h-4" /> Offers to help you
      </div>
      <div data-testid="review-offers-count" className="font-display text-xl text-forest mt-2">
        {n === 1 ? "A neighbour has offered to help" : `${n} neighbours have offered to help`}
      </div>
      <div className="mt-3 space-y-2.5">
        {data.requests.map((r) => (
          <div key={r.id} data-testid={`review-offers-row-${r.id}`} className="bg-white border border-amber-100 rounded-xl p-4 flex items-center gap-3 flex-wrap">
            <div className="flex-1 min-w-[180px]">
              <div className="font-medium text-forest text-sm">{r.title}</div>
              <div className="text-xs text-neutral-500 mt-0.5">
                {r.pending} pending offer{r.pending === 1 ? "" : "s"} to review
              </div>
            </div>
            <Link
              to={`/opportunities/${r.id}`}
              data-testid={`review-offers-link-${r.id}`}
              className="text-xs font-medium px-4 py-2 rounded-full bg-amber-600 text-white hover:bg-amber-700 transition-colors shrink-0 inline-flex items-center gap-1.5"
            >
              Review offers <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
